/**
 * @file 領域 (realm) のカタログ。
 *
 * @what: 教材・記録に付ける領域タグの語彙を持つ。空 (未設定) は学習を表す。習い事 (And Lives の「道すじ」の項目) と
 *   領域の対応もここに持つ (対応表はスタディ側で持つ合意。代表 2026-08-24)。
 * @why: 領域タブ化の第 2 段。サーバは形式しか見ないので、意味のある語彙はここが正。
 * @failure: 描画専用の定数。id を変えると教材・記録のタグと切れるので変えない。
 */

export interface Realm {
  id: string;
  label: string;
}

export const REALMS: readonly Realm[] = [
  { id: "motor", label: "うんどう" },
  { id: "music", label: "おんがく" },
  { id: "reading", label: "よむ" },
];

export const MUSIC_REALM_ID = "music";

/** 読書の記録に付ける領域タグ (よむタブ)。記録の器は StudyProgressLog を流用する。 */
export const READING_REALM_ID = "reading";

/**
 * And Lives の「道すじ」の項目 → 領域の対応 (項目名にこの語が含まれたらその領域の習い事とみなす)。
 * And Lives 側は独立更新のため、対応はスタディ側の手書きで持つ。
 */
export const REALM_ACTIVITY_KEYWORDS: Readonly<Record<string, readonly string[]>> = {
  music: ["バイオリン", "ヴァイオリン", "ピアノ", "リトミック"],
};
